import React from "react";

export const Shell = ({ children }) => (
  <div className="min-h-screen bg-[#0a0a0a] text-white" style={{ fontFamily: "Manrope, sans-serif" }}>
    <div className="max-w-6xl mx-auto px-6 py-10">{children}</div>
  </div>
);

export const Card = ({ children, className = "", ...rest }) => (
  <div {...rest} className={`bg-[#141414] border border-white/10 rounded-lg p-6 ${className}`}>{children}</div>
);

export const H1 = ({ children }) => (
  <h1 className="text-3xl font-bold tracking-tight" style={{ fontFamily: "Barlow Condensed, sans-serif" }}>{children}</h1>
);

export const Label = ({ children }) => <label className="block text-xs uppercase tracking-wide text-white/50 mb-1">{children}</label>;

export const Input = (props) => (
  <input {...props} className={`w-full bg-[#0a0a0a] border border-white/15 rounded px-3 py-2 text-sm text-white outline-none focus:border-[#00D26A] ${props.className || ""}`} />
);

export const Btn = ({ children, variant = "primary", ...p }) => {
  const base = "px-4 py-2 rounded text-sm font-semibold transition-colors disabled:opacity-40";
  const styles = variant === "primary" ? "bg-[#00D26A] text-black hover:bg-[#00B85C]"
    : variant === "ghost" ? "border border-white/15 text-white hover:border-[#00D26A]"
    : "bg-red-600/80 text-white hover:bg-red-600";
  return <button {...p} className={`${base} ${styles} ${p.className || ""}`}>{children}</button>;
};

export const Field = ({ label, ...p }) => (
  <div className="mb-3"><Label>{label}</Label><Input {...p} /></div>
);
